<template>
  <ValidationProvider :name="name">
    <v-switch
      :name="name"
      v-model="is_active"
      type="checkbox"
      :placeholder="placeholder"
      @change="updateValue"
      :label="label"
      :value="value"
    ></v-switch>
  </ValidationProvider>
</template>

<script>
export default {
  props: {
    name: {
      required: true,
    },
    label: {
      required: false,
    },
    rules: {
      required: false,
      default: "",
    },
    type: {
      required: false,
      default: "text",
    },
    value: {
      required: true,
    },
    placeholder: {
      required: false,
      default: " ",
    },
  },
  data() {
    return {
      is_active: true,
    };
  },
  methods: {
    updateValue(e) {
      this.$emit("input", e);
    },
  },
  mounted() {
    this.is_active = this.value;
  },
};
</script>

<style></style>
